import { SeuApiConverter, SeuCanvas, SeuCanvasApi } from '@seu-types';

export const canvasConverter: SeuApiConverter<SeuCanvas, SeuCanvasApi> = {
  fromApi: (input) => {
    const canvas: SeuCanvas = {
      ...input,
      canvasStreams: input.canvasStreams.map((canvasStream) => {
        return {
          ...canvasStream,
          outputFromComponentId: canvasStream.outputFromComponentId
            ? String(canvasStream.outputFromComponentId)
            : undefined,
          inputForComponentId: canvasStream.inputForComponentId
            ? String(canvasStream.inputForComponentId)
            : undefined,
          outputFromComponentHandleId:
            canvasStream.outputFromComponentHandleId ?? undefined,
          inputForComponentHandleId:
            canvasStream.inputForComponentHandleId ?? undefined,
        };
      }),
      components: input.components.map((component) => {
        return {
          ...component,
          componentId: String(component.componentId),
        };
      }),
    };

    return canvas;
  },
  toApi: (input) => {
    const canvas: SeuCanvasApi = {
      ...input,
      canvasStreams: input.canvasStreams.map((canvasStream) => {
        return {
          ...canvasStream,
          outputFromComponentId: canvasStream.outputFromComponentId
            ? Number(canvasStream.outputFromComponentId)
            : undefined,
          inputForComponentId: canvasStream.inputForComponentId
            ? Number(canvasStream.inputForComponentId)
            : undefined,
        };
      }),
      components: input.components.map((component) => {
        return {
          componentId: Number(component.componentId),
          posX: component.posX,
          posY: component.posY,
        };
      }),
    };
    return canvas;
  },
};
